// extracted by mini-css-extract-plugin
export default {"root":"IconShareListing_root__q3gAX"};